import React from 'react';
import { useTranslation } from 'react-i18next';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import LoadingContainer from '../../../shared/ui/loading-container/loading-container.jsx';

function SystemAclPageView({
  roles,
  isLoading,
  isSaving,
  error,
  success,
  deleteTarget,
  openCreateRole,
  openEditRole,
  confirmDeleteRole,
  cancelDeleteRole,
  deleteRole,
}) {
  const { t } = useTranslation();

  return (
    <div>
      <FloatingAlerts
        info={isSaving ? t('systemAcl.savingInfo') : ''}
        error={error}
        success={success}
      />

      <div className="app-page-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2>{t('systemAcl.title')}</h2>
          <p>{t('systemAcl.subtitle')}</p>
        </div>
        <button type="button" className="btn btn-primary" onClick={openCreateRole} disabled={isLoading || isSaving}>
          {t('systemAcl.addRole')}
        </button>
      </div>

      <div className="card card-body">
        <LoadingContainer isLoading={isLoading} hasData={roles.length > 0} initialText={t('common.loading')} className="table-responsive">
          <table className="table align-middle text-nowrap mb-0">
            <thead>
              <tr>
                <th>{t('systemAcl.colName')}</th>
                <th>{t('systemAcl.colSlug')}</th>
                <th>{t('systemAcl.colType')}</th>
                <th>{t('systemAcl.colPermissions')}</th>
                <th className="text-end">{t('systemAcl.colActions')}</th>
              </tr>
            </thead>
            <tbody>
              {roles.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center text-muted">{t('systemAcl.noRoles')}</td>
                </tr>
              ) : null}
              {roles.map((role) => (
                <tr key={role.id}>
                  <td>
                    <div className="fw-semibold">{role.name}</div>
                    {role.description ? <div className="text-muted small text-wrap">{role.description}</div> : null}
                  </td>
                  <td>{role.slug}</td>
                  <td>
                    <span className={`badge ${role.isSystem ? 'bg-light-primary text-primary' : 'bg-light-secondary text-secondary'}`}>
                      {role.isSystem ? t('systemAcl.systemRole') : t('systemAcl.customRole')}
                    </span>
                  </td>
                  <td>{role.permissions.length}</td>
                  <td className="text-end">
                    <div className="d-flex justify-content-end gap-2">
                      <button type="button" className="btn btn-sm btn-primary" onClick={() => openEditRole(role)} disabled={isSaving}>
                        <i className="fa fa-pen"></i>
                      </button>
                      {!role.isSystem ? (
                        <button type="button" className="btn btn-sm btn-danger" onClick={() => confirmDeleteRole(role)} disabled={isSaving}>
                          <i className="fa fa-trash"></i>
                        </button>
                      ) : null}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </LoadingContainer>
      </div>

      {deleteTarget ? (
        <>
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{t('systemAcl.deleteRoleTitle')}</h5>
                  <button type="button" className="btn-close" onClick={cancelDeleteRole}></button>
                </div>
                <div className="modal-body">
                  <p className="mb-0">{t('systemAcl.deleteRoleConfirm', { name: deleteTarget.name })}</p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-default" onClick={cancelDeleteRole} disabled={isSaving}>
                    {t('common.cancel')}
                  </button>
                  <button type="button" className="btn btn-danger" onClick={deleteRole} disabled={isSaving}>
                    {t('systemAcl.deleteRole')}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      ) : null}
    </div>
  );
}

export default SystemAclPageView;
